'use strict';

var store = require('fullstore/legacy');

var currify = require('currify/legacy');

var createElement = require('@cloudcmd/create-element');

require('../css/modal.css');

var parseImages = require('./parse-images');

var showTitle = require('./show-title');

var query = require('./query');

var getClassName = require('./get-class-name');

var noop = function noop() {};

var optionsStore = store({});
var html = "\n    <div class=\"modal-child\" data-name=\"modal-child\">\n        <div class=\"modal-close\" data-name=\"modal-close\"></div>\n    </div>\n";
var addEvent = currify(function (el, fn, name) {
  return query(el).addEventListener(name, fn);
});

var addAllEvents = function addAllEvents(el, fn, names) {
  return names.map(addEvent(el, fn));
};

var isArray = Array.isArray;

module.exports.open = function (inner) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  check(inner);
  if (query('main')) return;
  var _options$beforeShow = options.beforeShow,
      beforeShow = _options$beforeShow === void 0 ? noop : _options$beforeShow,
      _options$beforeClose = options.beforeClose,
      beforeClose = _options$beforeClose === void 0 ? noop : _options$beforeClose,
      _options$afterShow = options.afterShow,
      afterShow = _options$afterShow === void 0 ? noop : _options$afterShow,
      _options$afterClose = options.afterClose,
      afterClose = _options$afterClose === void 0 ? noop : _options$afterClose,
      _options$onOverlayCli = options.onOverlayClick,
      onOverlayClick = _options$onOverlayCli === void 0 ? noop : _options$onOverlayCli,
      _options$autoSize = options.autoSize,
      autoSize = _options$autoSize === void 0 ? false : _options$autoSize,
      _options$index = options.index,
      index = _options$index === void 0 ? 0 : _options$index,
      _options$helpers = options.helpers,
      helpers = _options$helpers === void 0 ? {} : _options$helpers,
      _options$title = options.title,
      title = _options$title === void 0 ? '' : _options$title;
  optionsStore({
    beforeClose: beforeClose,
    afterClose: afterClose
  });
  beforeShow();
  var isImage = isArray(inner);
  var isTitle = helpers.title && title || isImage;
  var className = getClassName({
    autoSize: autoSize,
    isTitle: isTitle
  });
  var el = createElement('div', {
    innerHTML: html,
    className: className,
    dataName: 'modal-main'
  });
  addAllEvents('main', onMainClick(onOverlayClick), ['click', 'contextmenu']);
  query('close').addEventListener('click', close);
  var child = query('child');
  if (isImage) return parseImages(child, inner, {
    index: index,
    afterShow: afterShow,
    helpers: helpers
  });
  child.appendChild(inner);
  if (isTitle) showTitle(title, child);
  afterShow();
  return el;
};

var onMainClick = currify(function (overlayClick, event) {
  if (event.target !== query('main')) return;
  close();
  overlayClick(event);
});

var close = function close() {
  var el = query('main');

  var _optionsStore = optionsStore(),
      _optionsStore$beforeC = _optionsStore.beforeClose,
      beforeClose = _optionsStore$beforeC === void 0 ? noop : _optionsStore$beforeC,
      _optionsStore$afterCl = _optionsStore.afterClose,
      afterClose = _optionsStore$afterCl === void 0 ? noop : _optionsStore$afterCl;

  if (!el) return;
  beforeClose();
  document.body.removeChild(el);
  afterClose();
};

module.exports.close = close;
module.exports._optionsStore = optionsStore;
module.exports._onMainClick = onMainClick;

function check(inner) {
  if (!inner) throw Error('inner should be DOM-element!');
}